import React from "react";
import { View, Text, StyleSheet } from "react-native";
import { helpers } from "../../utils/helpers";
import TouchableOpacityLink from "../../components/touchable-opacity-link";
import RocketIcon from "../../../../assets/img/rocket.png";
import CustomImage from "../../components/custom-image";

const AdBanner = () => {
  const isDesktop = helpers.isDesktop();

  return (
    <View style={styles.container}>
      <View
        style={[
          styles.innerContainer,
          isDesktop && styles.innerContainerDesktop,
        ]}
      >
        {/* LEFT: Event Image Placeholder */}
        {/* <View style={styles.imagePlaceholder}> */}
        <CustomImage
          source={RocketIcon}
          style={styles.rocketImage}
          webStyle={{ objectFit: "contain", height: 120 }}
          altText="Rocket"
        />
        {/* </View> */}

        {/* CENTER: Content */}
        <View style={styles.textContent}>
          <Text style={styles.badge}>TMC PRIVATE</Text>

          <Text
            style={[styles.title, !helpers.isDesktop() && styles.titleMobile]}
          >
            We are discussing deep tech. With AgniKul’s Srinath Ravichandran and
            Java Capital’s Vinod Shankar. Private is designed to be a small,
            quality get together.
          </Text>

          <View
            style={[
              styles.metaRow,
              !helpers.isDesktop() && styles.metaRowMobile,
            ]}
          >
            <Text style={styles.metaText}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-calendar h-3.5 w-3.5"
                aria-hidden="true"
                style={{ width: 14, height: 14 }}
              >
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
              </svg>{" "}
              8 May 2026
            </Text>
            <Text style={styles.metaText}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-clock h-3.5 w-3.5"
                aria-hidden="true"
                style={{ width: 14, height: 14 }}
              >
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M12 6v6l4 2"></path>
              </svg>{" "}
              4:00 PM IST
            </Text>
            <Text style={styles.metaText}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-map-pin h-3.5 w-3.5"
                aria-hidden="true"
                style={{ width: 14, height: 14 }}
              >
                <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>{" "}
              Bangalore
            </Text>
          </View>
        </View>

        {/* RIGHT: CTA */}
        <TouchableOpacityLink
          to={{ pathname: "/tmc-private/building-space-tech-in-india" }}
          // style={styles.ctaButton}
          style={{
            borderWidth: 1,
            borderColor: "#e5e7eb",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 10,
            paddingBottom: 10,
            backgroundColor: "#020618",
            textAlign: "center",
          }}
        >
          <Text style={styles.ctaText}>Reserve Your Seat →</Text>
        </TouchableOpacityLink>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#2cb680",
    paddingVertical: 24,
    paddingHorizontal: 16,
    width: "100%",
  },

  innerContainer: {
    maxWidth: 1200,
    width: "100%",
    marginHorizontal: "auto",
    flexDirection: "column",
    gap: 16,
  },

  innerContainerDesktop: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  /* LEFT IMAGE */
  imagePlaceholder: {
    width: 220,
    height: 120,
  },

  imageText: {
    color: "#94a3b8",
    fontSize: 12,
    letterSpacing: 2,
  },

  /* CENTER CONTENT */
  textContent: {
    flex: 1,
    marginHorizontal: 20,
  },

  badge: {
    color: "#ffffff",
    fontSize: 14,
    letterSpacing: 2,
    marginBottom: 8,
    fontFamily: "HaasGrotesk-Medium",
    fontWeight: "500",
  },

  badgeLight: {
    color: "#64748b",
  },

  title: {
    color: "#ffffff",
    fontSize: 24,
    lineHeight: 32,
    fontWeight: "600",
    marginBottom: 10,
    fontFamily: "PlayfairDisplay-Bold",
    fontWeight: "700",
  },

  titleMobile: {
    fontSize: 18,
    lineHeight: 28,
    marginBottom: 12,
  },

  metaRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 16,
  },

  metaRowMobile: {
    gap: 12,
  },

  metaText: {
    color: "#ffffff",
    fontFamily: "HaasGrotesk-Regular",
    fontWeight: "400",
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },

  /* CTA */
  ctaButton: {
    borderWidth: 1,
    borderColor: "#e5e7eb",
    paddingVertical: 10,
    paddingHorizontal: 18,
    borderRadius: 6,
    alignSelf: "flex-start",
  },

  ctaText: {
    color: "#ffffff",
    fontSize: 14,
    letterSpacing: 1,
  },
});

export default AdBanner;
